import React from "react";
import moment from "moment";
import { APP_NAME, APP_SEPARATOR } from "constants/appInfo";

import { dateFormat } from "utils";
import { Table, CardsList } from "components";

export const List = (props) => {
  const { cards } = props;
  return cards === true ? <CardsList {...props} /> : <Table {...props} />;
};

export function title(pageName) {
  return <title>{`${APP_NAME} ${APP_SEPARATOR} ${pageName}`}</title>;
}

export function imagePath(image, thumbnail = false) {
  var path = (image || {}).url;
  if (thumbnail && image && "thumb" in image) path = (image.thumb || {}).url || "";
  return path || "";
}

export function serialize(obj) {
  var str = [];
  for (var p in obj)
    if (obj.hasOwnProperty(p)) {
      if (Array.isArray(obj[p]))
        obj[p].forEach((val) => str.push(encodeURIComponent(p) + "[]=" + encodeURIComponent(val)));
      else str.push(encodeURIComponent(p) + "=" + encodeURIComponent(obj[p]));
    }

  return str.join("&");
}

export const renderProjectSelectOption = (project) => (
  <span
    className="project-select-option"
    value={`${project.code} : ${project.label} ` + project?.client?.name}
  >
    <i>{`${project.code} : ${project.label}`}</i>
    <small>{project?.client?.name}</small>
  </span>
);

export function formatMaterialFilters(filters, material) {
  var { pnum = 0, per = 0, orderby, dir } = material;
  var pagination = "",
    order = "";

  if (pnum !== 0) pagination = `&page_number=${pnum}&per_page=${per}`;
  if (orderby)
    order = `&order_by=${orderby.orderField ? orderby.orderField : orderby.field}&order_direction=${dir.toUpperCase()}`;

  return serializeMaterialFilter(filters) + pagination + order;
}

export function serializeMaterialFilter(filters) {
  var str = [];

  filters.forEach((filter) => {
    if (filter.column.field === "date") {
      const isDate = (date) => !isNaN(Date.parse(date));
      const value = filter.value;
      const toDate = (dateStr) => {
        const char = dateStr.indexOf("/") !== -1 ? "/" : "-";
        const [day, month, year] = dateStr.split(char);
        return new Date(year, month - 1, day);
      };

      var range = value.split("//");
      range.map((date) => {
        date = toDate(date);
        if (!isDate(date)) return;

        date = moment(date).format("YYYY-MM-DD");
        str.push(encodeURIComponent(filter.column.field) + "[]=" + encodeURIComponent(date));
      });
    } else {
      if (filter.value === "checked") filter.value = 1;
      if (filter.value === "unchecked") filter.value = 0;

      if (Array.isArray(filter.value)) {
        filter.value.forEach((val) =>
          str.push(encodeURIComponent(filter.column.field) + "[]=" + encodeURIComponent(val)),
        );
      } else {
        str.push(encodeURIComponent(filter.column.field) + "=" + encodeURIComponent(filter.value));
      }
    }
  });

  return str.join("&");
}
